import { MenuIdPeople } from '@jira/navigation-apps__constants/src/MenuIdPeople.tsx';
import {
	AsyncHorizontalOperationsNav,
	LazyHorizontalOperationsNav,
} from '@jira/navigation-apps__horizontal-nav-jsm-operations-container/src/async.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { LazyTeamDashboardSidebar } from '@jira/navigation-apps__sidebar-eoc-team-dashboard/src/async.tsx';
import { opsTeamLayout } from '@jira/platform__layouts-ops-team-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { eocReportsTeamRedirectRoute } from '@jira/router-routes__eoc-reports-routes/src/eocReportsTeamRedirectRoute.tsx';
import { resources as teamDashboardResources } from '@atlassian/eoc-team-dashboard/resources';
import {
	resources as opsReportsResources,
	opsReportsPermissionResource,
} from '@atlassian/eoc-ops-reports-common/resources';
import type { Route } from '@atlassian/react-resource-router';
import { LazyOpsReportsRedirect, OpsReportsRedirect } from './ui/spa/eoc/ops-reports/index.tsx';

export const eocReportsTeamRedirectRouteEntry: Route = createEntry(
	eocReportsTeamRedirectRoute,
	() => ({
		group: 'eoc',
		// eslint-disable-next-line no-restricted-syntax
		component: OpsReportsRedirect,
		layout: opsTeamLayout,

		resources: [
			...getNavigationResources(),
			...teamDashboardResources(),
			...opsReportsResources(),
			opsReportsPermissionResource,
			getConsolidationStateResource(),
		],

		navigation: {
			menuId: MenuIdPeople,
			horizontal: AsyncHorizontalOperationsNav,
		},

		forPaint: [
			LazyHorizontalOperationsNav,
			LazyAtlassianNavigation,
			LazyOpsReportsRedirect,
			LazyTeamDashboardSidebar,
		],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
